import GoodOTBoldWoff2 from '@assets/fonts/GoodOT-Bold.woff2'
import GoodOTMediumWoff2 from '@assets/fonts/GoodOT-Medium.woff2'
import GoodOTRegularWoff2 from '@assets/fonts/GoodOT-Regular.woff2'
import GoodOTUltraWoff2 from '@assets/fonts/GoodOT-Ultra.woff2'
import GoodOTUltraItalicWoff2 from '@assets/fonts/GoodOT-UltraItalic.woff2'
import GoodOTCondUltraWoff2 from '@assets/fonts/GoodOTCond-Ultra.woff2'
import GoodOTNarrowUltraWoff2 from '@assets/fonts/GoodOTNarrow-Ultra.woff2'
import SourceSansProBoldWoff2 from '@assets/fonts/SourceSansPro-Bold.woff2'
import SourceSansProRegularWoff2 from '@assets/fonts/SourceSansPro-Regular.woff2'
import SourceSansProSemiBoldWoff2 from '@assets/fonts/SourceSansPro-SemiBold.woff2'
import { FunctionComponent } from 'react'

const FontPreloadWeb: FunctionComponent = () => (
  <>
    <link
      rel="preload"
      href={SourceSansProRegularWoff2}
      as="font"
      type="font/woff2"
      crossOrigin="anonymous"
    />
    <link
      rel="preload"
      href={SourceSansProSemiBoldWoff2}
      as="font"
      type="font/woff2"
      crossOrigin="anonymous"
    />
    <link
      rel="preload"
      href={SourceSansProBoldWoff2}
      as="font"
      type="font/woff2"
      crossOrigin="anonymous"
    />
    <link
      rel="preload"
      href={GoodOTRegularWoff2}
      as="font"
      type="font/woff2"
      crossOrigin="anonymous"
    />
    <link
      rel="preload"
      href={GoodOTMediumWoff2}
      as="font"
      type="font/woff2"
      crossOrigin="anonymous"
    />
    <link
      rel="preload"
      href={GoodOTBoldWoff2}
      as="font"
      type="font/woff2"
      crossOrigin="anonymous"
    />
    <link
      rel="preload"
      href={GoodOTUltraWoff2}
      as="font"
      type="font/woff2"
      crossOrigin="anonymous"
    />
    <link
      rel="preload"
      href={GoodOTUltraItalicWoff2}
      as="font"
      type="font/woff2"
      crossOrigin="anonymous"
    />
    <link
      rel="preload"
      href={GoodOTCondUltraWoff2}
      as="font"
      type="font/woff2"
      crossOrigin="anonymous"
    />
    <link
      rel="preload"
      href={GoodOTNarrowUltraWoff2}
      as="font"
      type="font/woff2"
      crossOrigin="anonymous"
    />
  </>
)

const FontFacesWeb = `
  @font-face {
    font-family: 'Source Sans Pro';
    src: url('${SourceSansProRegularWoff2}') format('woff2');
    font-style: normal;
    font-weight: 400;
    font-display: swap;
  }

  @font-face {
    font-family: 'Source Sans Pro';
    src: url('${SourceSansProSemiBoldWoff2}') format('woff2');
    font-style: normal;
    font-weight: 600;
    font-display: swap;
  }

  @font-face {
    font-family: 'Source Sans Pro';
    src: url('${SourceSansProBoldWoff2}') format('woff2');
    font-style: normal;
    font-weight: bold;
    font-display: swap;
  }

  @font-face {
    font-family: 'GoodOT';
    src: url('${GoodOTRegularWoff2}') format('woff2');
    font-style: normal;
    font-weight: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'GoodOT';
    src: url('${GoodOTMediumWoff2}') format('woff2');
    font-style: normal;
    font-weight: 500;
    font-display: swap;
  }

  @font-face {
    font-family: 'GoodOT';
    src: url('${GoodOTBoldWoff2}') format('woff2');
    font-style: normal;
    font-weight: bold;
    font-display: swap;
  }

  @font-face {
    font-family: 'GoodOT';
    src: url('${GoodOTUltraWoff2}') format('woff2');
    font-style: normal;
    font-weight: 900;
    font-display: swap;
  }

  @font-face {
    font-family: 'GoodOT';
    src: url('${GoodOTUltraItalicWoff2}') format('woff2');
    font-style: italic;
    font-weight: 900;
    font-display: swap;
  }

  @font-face {
    font-family: 'GoodOTCond';
    src: url('${GoodOTCondUltraWoff2}') format('woff2');
    font-style: normal;
    font-weight: 900;
    font-display: swap;
  }

  @font-face {
    font-family: 'GoodOTNarrow';
    src: url('${GoodOTNarrowUltraWoff2}') format('woff2');
    font-style: normal;
    font-weight: 900;
    font-display: swap;
  }
`

export { FontPreloadWeb, FontFacesWeb }
